export const ACTION_ADD_ALERT = 'ADD_ALERT';
export const ACTION_REMOVE_ALERT_BY_ID = 'REMOVE_ALERT_BY_ID';
export const ACTION_REMOVE_ALL_ALERTS = 'REMOVE_ALL_ALERTS';

export const MAX_VISIBLE_ALERTS_COUNT = 4;
